import React from "react";
import PhoneMissedIcon from "@mui/icons-material/PhoneMissed";
import LocalPhoneIcon from "@mui/icons-material/LocalPhone";
import styles from "./callhistory.module.css";

//좌측 행·우측 헤더 공용 원형 아바타: 콜백 필요 → 빨간 부재중 아이콘, 이름 있으면 첫 글자, 없으면 전화 아이콘
const ContactAvatar : React.FC<any> = (props) => {
    const c = props.contact || {};
    const size = props.size || 38;
    const isCallback = !c.hidden && !!c.callbackNeeded;
    const initial = (c.displayName || "").trim().charAt(0);

    return (
        <div
            className={`${styles.avatar} ${isCallback ? styles.avatarRed : styles.avatarBeige}`}
            style={{ width: `${size}px`, height: `${size}px` }}
        >
            {
                isCallback ?
                    <PhoneMissedIcon sx={{ fontSize: Math.round(size * 0.45) }} />
                    : initial ?
                        <span className={styles.avatarInitial} style={{ fontSize: `${Math.round(size * 0.4)}px` }}>{initial}</span>
                        : <LocalPhoneIcon sx={{ fontSize: Math.round(size * 0.42), color: "#9C9483" }} />
            }
        </div>
    );
};

export default ContactAvatar;
